module.exports = __webpack_public_path__ + "static/media/running_man_pers.a9b8f25d.svg";